import React from 'react';
import { CreditCardIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { finalCtaCopy, offer, trustBadges } from '../data/content';
interface FinalCtaCopy {
  title: string;
  subtitle: string;
  summary: string;
  cta: string;
}
interface FinalCtaProps {
  copy?: FinalCtaCopy;
}
export function FinalCta({
  copy = finalCtaCopy
}: FinalCtaProps) {
  return <section className="w-full bg-white py-14 md:py-20" data-id="element-67" data-mp="1jcd4g9xq3yc0">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-68" data-mp="1jasaomj8gjf7">
        <div className="mx-auto max-w-3xl text-center" data-id="element-69" data-mp="1ed8yds63igpw">
          <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-70" data-mp="1t2ol8x2ia20b">
            {copy.title}
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-blue-900/75" data-id="element-71" data-mp="1o4ddqszoo3l9">{copy.subtitle}</p>
        </div>

        <div className="mx-auto mt-10 max-w-lg rounded-2xl bg-white p-6 text-center shadow-lg ring-2 ring-blue-600 sm:p-8" data-id="element-72" data-mp="223w7uhvnteek">
          <h3 className="text-lg font-extrabold uppercase leading-snug tracking-tight text-slate-900" data-id="element-73" data-mp="1x2p0gjxfih8f">
            {offer.name}
          </h3>
          <p className="mt-1 font-semibold text-blue-600" data-id="element-74" data-mp="s5qobwnsb6u7">{copy.summary}</p>
          <p className="mt-5 text-5xl font-extrabold tracking-tight text-slate-900" data-id="element-75" data-mp="x41x042cfbau">
            {offer.price}
            <span className="ml-2 text-lg font-semibold text-blue-900/55" data-id="element-76" data-mp="12354rw9pjvmi">{offer.currency}</span>
          </p>
          <div className="mt-6" data-id="element-77" data-mp="163f9z6poei0b">
            <CtaButton size="lg" className="w-full" data-id="element-78" data-mp="1646w7qxdv3dx">
              {copy.cta}
            </CtaButton>
          </div>
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-medium text-blue-900/70" data-id="element-79" data-mp="1b171w0qbm44i">
            <li className="inline-flex items-center gap-1.5" data-id="element-80" data-mp="1ktw8ah70krsz">
              <ZapIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-81" data-mp="1kvfu0nbfvv25" /> {trustBadges.access}
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-82" data-mp="1tu1742y56hvj">
              <CreditCardIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-83" data-mp="1tukrrrf6fkd9" />{' '}
              {trustBadges.payment}
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-84" data-mp="3lvuertp2775a">
              <ShieldCheckIcon className="h-4 w-4 text-emerald-500" aria-hidden="true" data-id="element-85" data-mp="3lxf85fzn0k1k" />{' '}
              {trustBadges.guarantee}
            </li>
          </ul>
        </div>
      </div>
    </section>;
}